<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='金牌讲解员'">
    <!--<div class="img-box" :class="videoShow==1?'curr':''">-->
    <div class="img-box">
      <img class="img" :src="guideInfo.logo" alt="">
      <img class="icon-video" src="../../assets/icon-bf1.png" alt="" v-show="guideInfo.video&&videoShow==0" @click="playVideo">
      <!--<video id="videoPlay" :src="guideInfo.video" @click="playVideo" @play="play()" preload="auto" webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow"></video>-->

    </div>
    <div class="info-box border-box">
      <div class="info-top">
        <div class="t1">{{guideInfo.name}}<span class="t2" v-if="guideInfo.tag">{{guideInfo.tag}}</span></div>
        <div class="star">
          <template v-for="(star,index) in [1,2,3,4,5]">
            <img v-if="guideInfo.score>=star" src="../../assets/icon-star-curr.png"/>
            <img v-else  src="../../assets/icon-star.png" />
          </template>
          <span class="fl" v-if="guideInfo.score">{{guideInfo.score}}分</span>
        </div>
      </div>
      <div class="info-bot" v-if="guideInfo.info" v-html="guideInfo.info"></div>
    </div>

    <div class="comment-box border-box">
      <div class="title clearfix">
        <div class="fl tit-line"><b></b><span>游客评价</span></div>
      </div>
      <div v-if="root&&root.length>0">
        <div class="comment-item box" v-for="(item,index) in root">
          <img class="l" :src="item.headimg" alt="">
          <div class="flex r">
            <div class="intro box">
              <div class="flex">
                <div class="hide">{{item.username}}</div>
                <div class="star">
                  <template v-for="(star,index) in [1,2,3,4,5]">
                    <img v-if="item.score>=star" src="../../assets/icon-star-curr.png"/>
                    <img v-else  src="../../assets/icon-star.png" />
                  </template>
                </div>
              </div>
              <div class="time">{{item.addtime.slice(0,10)}}</div>
            </div>
            <div class="desc">{{item.content}}</div>
            <div class="comment-img clearfix" v-if="item.img&&(item.img).split(',').length>0">
              <img class="img" :src="ite" alt="" v-for="(ite,ind) in (item.img).split(',')"   @click="seeComImg(ite,(item.img).split(','))">
            </div>
          </div>
        </div>
      </div>
      <div class="load-tip" v-if="!root||root.length<1">暂无评论~</div>

    </div>

    <img class="to-home" src="../../assets/to-home.png" @click="toHome" alt="" >

    <!--视频播放弹窗-->
    <div class="alert-video" v-show="videoShow==1">
      <div class="mask"></div>
      <img class="video-close" @click="pauseVideo" src="../../assets/close.png" alt="" >
      <video id="videoPlay" :src="guideInfo.video" controls preload="auto" webkit-playsinline="true" playsinline="true" x5-playsinline="true" x-webkit-airplay="allow"></video>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {getScenicGuideDetail} from "@/service/getData";
  import {wxGetPosition,wxShareme,wxImgPreview} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        id: this.$route.query.id || '',//导游ID

        P400: 0, //系统维护中
        guideInfo:'',//导游详情
        root: [], //评论列表
        page: 1, //加载更多
        pageSize:10,
        loadText: "数据加载中",
        videoShow:0,//视频弹窗
        isVideoPlay: false //视频没有在播放
      }
    },
    computed: {},

    created(){
      this.getScenicGuideDetailFun(this.page);
      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {

      //获取导游详情
      async getScenicGuideDetailFun(){
        let res = await getScenicGuideDetail({
          guideId : this.id,
      time: (new Date().getTime())
        });
        if (res.errcode == "00000") {
          this.guideInfo = res.data
        }else {
          this.$toast(res.errmsg);
        }
      },

      //获取评论数据
      async getScenicGuideDetailFun(page){
        let res = await getScenicGuideDetail({
          guideId : this.id,
          pageNum: page,
          pageSize: this.pageSize,
      time: (new Date().getTime())
        });
        if (res.errcode === '00000') {
          this.total = res.data.total;
          this.guideInfo = res.data.guide
          let root = res.data.root
          if (page >= Math.ceil(this.total / this.pageSize)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

        }else {
          this.$toast(res.errmsg);
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.getScenicGuideDetailFun(page);
          });
        })
      },

    //评论图片预览
    seeComImg:function(img,imgs){
      wxImgPreview(img,imgs);
    },
    //返回至首页
    toHome(){
      this.$router.replace({path: `/?scenicId=`+this.scenicId+'&scenicKey='+this.scenicKey});
    },

    //新增视频播放
    playVideo(){
      this.videoShow = 1;
      var vdo = document.getElementById("videoPlay");
      if (vdo.paused) {
        vdo.play();
//        vdo.playbackRate = 2;
        this.isVideoPlay = true;
//        this.videoShow = 1;
      } else {
        vdo.pause();
        this.isVideoPlay = false;
        this.videoShow = 0;
      }
    },
    pauseVideo(){
      var vdo = document.getElementById("videoPlay");
      vdo.pause();
      this.isVideoPlay = false;
      this.videoShow = 0;
    },
    play(){
      var self = this;
      var vdo = document.getElementById("videoPlay");
      vdo.addEventListener('ended', function () { //播放结束
        self.isVideoPlay = false;
      }, false);
    },
  },
    watch: {},
    components: {
        P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  .page{width: 100vw;min-height: 100vh;padding-bottom:.4rem;background: #ededed;}
  .img-box{position: relative;width: 100%;height: 117.2vw;overflow: hidden;}
  .img-box img{width: 100%;height: 100%;object-fit: cover;object-position: top;}
  .img-box video{opacity:0;z-index: -1;position: absolute;top:50%;left:0%; width: 100%; height: auto;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .img-box.curr .img{-webkit-animation: imgBox .6s linear;animation: imgBox .6s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  @keyframes imgBox {from{ filter:blur(0);}to{ filter:blur(10px);}}
  @keyframes videoAni{from{opacity:0;z-index: -1;}to{opacity:1;z-index: 9;}} {

  }
  /*.img-box.curr video{-webkit-animation: videoAni .3s linear .2s;animation: videoAni .3s linear .2s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}*/
  .img-box video{-webkit-animation: videoAni .3s linear .2s;animation: videoAni .3s linear .2s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}


  .img-box .icon-video{position: absolute;top:50%;left: 50%;z-index: 10;width: 1.16rem;height: 1.16rem;margin-left: -.58rem;margin-top: -.58rem;}

  .info-box{position:relative;z-index: 10;padding: .3rem .24rem;margin: -20% .24rem 0;border-radius: .2rem;background: #fff;box-shadow: .08rem .08rem .08rem rgba(0,0,0,.08);}
  .info-box .info-top{position: relative;}
  .t1{height:.5rem;font: bold .32rem/.5rem "Microsoft YaHei";color: #333;}
  .t2{position:relative;display: inline-block;height:.5rem;padding-left:.21rem;font: .28rem/.5rem "Microsoft YaHei";color: #666;}
  .t2:before{content: '';position: absolute;top:.13rem;bottom:.13rem;left:.1rem;width: .02rem;background: #666;}
  .info-box .star{height: .26rem;margin-top: .24rem;}
  .info-box .star img{float:left;width: auto;height: .26rem;margin-right: .1rem;}
  .info-box .star span{font-size: .2rem;color: #666;}
  .info-box .info-bot{margin-top: .3rem;font: .25rem/.42rem "Microsoft YaHei";color: #666;}
  .comment-box{padding:.4rem .3rem;margin: .27rem .24rem 0;background: #fff;border-radius: .2rem;}
  .comment-item{margin-top: .4rem;}
  .comment-item:first-child{margin-top: .55rem;}
  .comment-item .l{width: .64rem;height: .64rem;margin-right: .14rem;border-radius: 50%;object-fit: cover;object-position: top;}
  .comment-item .intro{height: .64rem;font-size: .28rem;color: #333;}
  .comment-item .star{width: 100%;height: .23rem;margin-top: .06rem;}
  .comment-item .star img{float: left;width: auto;height: .23rem;margin-right: .1rem;}
  .comment-item .time{font-size: .24rem;color: #999;}
  .comment-item .desc{margin-top:.14rem;font: .28rem/.42rem "Microsoft YaHei";color: #333;}
  .comment-item .comment-img{margin-top: .16rem;}
  .comment-item .img{float:left;width: 32.3%;height:1.8rem;margin-right: 1%;border-radius: .2rem;object-fit:cover;overflow: hidden;}

  /*视频弹窗*/
  .alert-video{position: fixed;top:0;left: 0;z-index:11;width: 100%;height: 100%;}
  .alert-video video{position:relative;width: 100%;height: 100%; object-fit: cover;}
  .video-close{position: absolute;right: 0.24rem;top: 0.24rem;z-index: 9;width: .6rem;height: .6rem;}

</style>



// WEBPACK FOOTER //
// src/page/home/guide.vue